<template>
  <div>
    <table
      v-if="!loading && data.length"
      class="table"
    >
      <thead>
        <tr>
          <th>Ресурc</th>
          <th>Ссылка</th>
          <th>Тональность</th>
          <th>Рейтинг</th>
          <th>Посл.отзыв</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(item, index) in data"
          :key="index"
        >
          <td>{{ item.site }}</td>
          <td><a :href="item.url">{{ item.url }}</a></td>
          <td>
            <img
              :src="checkTone(item.hostRating) ? require(`../../img/emoticons/${item.hostRating}.svg`) : null"
              :alt="item.hostRating"
            >
          </td> <!-- TODO: помоему в api ключ перепутан с тональностью -->
          <td />
          <td />
        </tr>
      </tbody>
    </table>
    <no-data v-if="!loading && !data.length" />
  </div>
</template>

<script>
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import analytics from './mixins/analytics'

export default {
  name: 'AnalyticsCommon',
  components: { NoData },
  mixins: [analytics],
  props: {
    data: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  }
}
</script>
